var React = require('react');

function CheckSuccess (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#k8wr9lfrza)","stroke":"#169E8F","strokeWidth":"2.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0},[React.createElement("path",{"d":"M33.565 17.304 19.217 30.696l-4.782-4.783","key":0}),React.createElement("path",{"d":"M24 46c12.15 0 22-9.85 22-22S36.15 2 24 2 2 11.85 2 24s9.85 22 22 22z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"k8wr9lfrza"},React.createElement("path",{"fill":"#fff","d":"M0 0h48v48H0z"})))]);
}

CheckSuccess.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CheckSuccess;

CheckSuccess.default = CheckSuccess;
